/* Custom Size dropdown delegates variant/cart resolution to product-variants. */
(function () {
  function init(root = document) {
    root.querySelectorAll('.custom-select').forEach((select) => {
      if (select.dataset.sizePickerInitialized) return;
      const picker = select.closest('product-variants');
      const selected = select.querySelector('.custom-selected');
      const list = select.querySelector('.custom-options');
      const radios = picker?.querySelector('.product-variant__container.size');
      if (!selected || !list || !radios) return;
      select.dataset.sizePickerInitialized = 'true';
      const options = Array.from(list.querySelectorAll('.custom-option'));
      selected.setAttribute('role', 'button');
      selected.setAttribute('tabindex', '0');
      selected.setAttribute('aria-label', 'Vælg stelstørrelse');
      selected.setAttribute('aria-haspopup', 'listbox');
      list.setAttribute('role', 'listbox');
      const setOpen = (open) => {
        select.classList.toggle('open', open);
        selected.setAttribute('aria-expanded', String(open));
        list.setAttribute('aria-hidden', String(!open));
      };
      const sync = () => {
        const value = radios.querySelector('input:checked')?.value;
        const option = options.find((opt) => opt.dataset.value === value);
        if (!option) return;
        selected.innerHTML = option.innerHTML;
        select.dataset.selectedValue = value;
        selected.setAttribute('aria-label', `Stelstørrelse: ${value}`);
        options.forEach((opt) => opt.setAttribute('aria-selected', String(opt === option)));
      };
      const choose = (option) => {
        const radio = Array.from(radios.querySelectorAll('input')).find((input) => input.value === option.dataset.value);
        if (!radio) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
        setOpen(false);
        selected.focus();
      };
      options.forEach((option, index) => {
        option.setAttribute('role', 'option');
        option.setAttribute('tabindex', '-1');
        option.addEventListener('click', () => choose(option));
        option.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); choose(option); }
          if (event.key === 'Escape') { setOpen(false); selected.focus(); }
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            options[(index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length].focus();
          }
        });
      });
      selected.addEventListener('click', () => setOpen(!select.classList.contains('open')));
      selected.addEventListener('keydown', (event) => {
        if (['Enter', ' ', 'ArrowDown', 'ArrowUp'].includes(event.key)) {
          event.preventDefault(); setOpen(true);
          (options.find((opt) => opt.dataset.value === select.dataset.selectedValue) || options[0])?.focus();
        }
        if (event.key === 'Escape') setOpen(false);
      });
      document.addEventListener('click', (event) => { if (!select.contains(event.target)) setOpen(false); });
      picker.addEventListener('VARIANT_CHANGE', sync);
      setOpen(false);
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
